export default function RecommendationsSection({ recommendations }: { recommendations: string[] }) {
  const list = recommendations || [];

  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 pt-12 md:px-8 md:pt-14">
      <div className="mb-5 flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-teal-50 text-teal-700">
          <i className="ri-lightbulb-flash-line" />
        </span>
        <h2 className="text-lg font-bold text-slate-900 md:text-[1.5rem]">改善建議</h2>
      </div>

      {list.length === 0 ? (
        <div className="rounded-lg border border-dashed border-slate-300 bg-slate-50/60 p-6 text-center text-sm text-slate-500">
          尚無改善建議，待健診結果產生後顯示。
        </div>
      ) : (
        <ul className="grid grid-cols-1 gap-3 md:grid-cols-2">
          {list.map((text, index) => (
            <li
              key={index}
              className="flex items-start gap-3 rounded-lg border border-slate-200 bg-white p-4 text-sm leading-relaxed text-slate-700"
            >
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-slate-100 text-slate-500">
                <i className="ri-check-line text-sm" />
              </span>
              {text}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}